export const contentDict = {
  title: "Deep 3D Compression",                // Display name
  finishDate: new Date("2023-03-31"),     // format is YYYY-MM-DD
  tools: {                                // Dict of languages and percentages (should add up to 1)
    "Python": 0.5,
    "PyTorch": 0.5, 
  }, 
  description: 
    `We used a shaped-coded auto-decoder and sinusoidal activations for compression of 3D shapes. 
    Herein, we specifically compared memory-use and compression speed with the expressive power of the method.`,
  tags: ["ML", "CV", "SDF"],
  github: "https://github.com/philippwulff/Deep3DComp",    // Can also be `null`
  website: "https://philippwulff.github.io/Deep3DComp/",       // Can also be `null`
  images: [
    "https://philippwulff.github.io/Deep3DComp/static/images/arch.png",
    "https://philippwulff.github.io/Deep3DComp/static/videos/planes_2.mp4"
  ],
  coverImg: "https://philippwulff.github.io/Deep3DComp/static/images/arch.png",
  mainColor: "#000",
  authors: ["Philipp Wulff", "Leonard Freißmuth"],
  isResearch: true,    // Whether this should be in the research section
};

// export default contentDict;
// module.exports = { contentDict: 'contentDict' }